import React, { Component } from 'react'

class PromotionVariantTopicPartnerComponent extends Component {
    render() {
        return (
            <div></div>
        )
    }
}

export default PromotionVariantTopicPartnerComponent


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/topicPartner.js